import React from 'react'
import Navbar from './component/Navbar'
import Pages from './component/Pages'

const App = () => {
  
  return (
    <div>
      <Navbar />
      <Pages  />
    </div>
  )
}

export default App
